<template>
	<!-- редактирование открытого списка целей -->
	<div ng-if="overlayController" class="windowOverlay" id="farmListEdit" ng-controller="overlayController">
		<div class="darkener clickable" clickable="closeOverlay()" @click="gameModel.buildings.area.farmListEditShow = false"></div>
		<div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="706">
			<div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
				<div class="inWindowPopupHeader">
					<h4 translate="" options="FarmList.ListEdit.headline" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Редактировать список</span></h4>
					<h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4>
					<a class="closeOverlay clickable" clickable="closeOverlay()" translate=""><span>Закрыть</span></a>
				</div>
				<div class="inWindowPopupContent">
					<div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']">
						<div class="farmListEdit">
							<label for="farmListEditInput" translate=""><span>Название списка</span></label>
							<input id="farmListEditInput" type="text" maxlength="15" ng-model="input.listName" placeholder="Новое название" auto-focus="" class="ng-pristine ng-valid ng-valid-maxlength ng-touched" />
						</div>
						<div class="buttonFooter">
							<button clickable="editList()" ng-class="{disabled: listName == ''}" class="clickable">
								<div class="content">
									<span ng-transclude="" class="innerText">
										<span translate=""><span>Сохранить</span></span>
									</span>
									<!-- ngIf: price > 0 || forceGoldUsage -->
									<!-- ngIf: price == -1 && !forceGoldUsage -->
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
							<button clickable="closeOverlay();" @click="gameModel.buildings.area.farmListEdit = false" class="cancel clickable">
								<div class="content">
									<span ng-transclude="" class="innerText">
										<span translate=""><span>Отмена</span></span>
									</span>
									<!-- ngIf: price > 0 || forceGoldUsage -->
									<!-- ngIf: price == -1 && !forceGoldUsage -->
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
						</div>
						<div class="error"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>